/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Open_BodyInputs */

const en_us2_workout_quick_open_body = /** @type {(inputs: Workout_Quick_Open_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To log this one, that one will be closed without counting as a workout. Its sets stay saved.`)
};

const pt_br2_workout_quick_open_body = /** @type {(inputs: Workout_Quick_Open_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para registrar este, aquele será encerrado sem contar como treino. As séries dele continuam salvas.`)
};

const es_419_workout_quick_open_body = /** @type {(inputs: Workout_Quick_Open_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para registrar este, aquel se cerrará sin contar como entrenamiento. Sus series quedan guardadas.`)
};

const pt_pt2_workout_quick_open_body = /** @type {(inputs: Workout_Quick_Open_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para registar este, aquele será terminado sem contar como treino. As séries dele continuam guardadas.`)
};

const fr_fr2_workout_quick_open_body = /** @type {(inputs: Workout_Quick_Open_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour noter celle-ci, l'autre sera fermée sans compter comme une séance. Ses séries restent enregistrées.`)
};

const de_de2_workout_quick_open_body = /** @type {(inputs: Workout_Quick_Open_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um dieses einzutragen, wird das andere beendet, ohne als Training zu zählen. Seine Sätze bleiben gespeichert.`)
};

const it_it2_workout_quick_open_body = /** @type {(inputs: Workout_Quick_Open_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per registrare questo, quello verrà chiuso senza contare come allenamento. Le sue serie restano salvate.`)
};

/**
* | output |
* | --- |
* | "To log this one, that one will be closed without counting as a workout. Its sets stay saved." |
*
* @param {Workout_Quick_Open_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_open_body = /** @type {((inputs?: Workout_Quick_Open_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Open_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_open_body(inputs)
	if (locale === "es-419") return es_419_workout_quick_open_body(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_open_body(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_open_body(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_open_body(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_open_body(inputs)
	return en_us2_workout_quick_open_body(inputs)
});
export { workout_quick_open_body as "workout-quick.open_body" }